"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 0l2.5 5.3 5.5.8-4 4.1.9 5.8L8 13.3 3.1 16l.9-5.8-4-4.1 5.5-.8z"];
//# sourceMappingURL=star.js.map